import { MappedImage } from "src/utils/fw";
import { IAMetadata, ISFAssure } from "./dayOne";
import membership from "./membership";

const IsfResearch = () => {
    const bg = "https://assets.swoogo.com/uploads/full/4594565-672280a6861ba.png"

    return <MappedImage imageURL={bg} links={[
        {
            label: "Leadership Insights series",
            href: "https://www.isflive.org/s/topic/0TO0J000000U7KEWA0/leadership-and-strategy",
            target: "_blank",
            width: "38.6%",
            height: "8%",
            left: "11%",
            top: "31%"
        },
        {
            label: "Threat Horizon",
            href: "https://www.isflive.org/s/topic/0TO0J0000009AODWA2/threat-horizon",
            target: "_blank",
            width: "38.6%",
            height: "8%",
            left: "11%",
            top: "42%"
        },
        {
            label: "Upcoming research",
            href: "https://www.isflive.org/s/research-in-development",
            target: "_blank",
            width: "38.6%",
            height: "8%",
            left: "11%",
            top: "53%"
        },
        {
            label: "AI Insights series",
            href: "https://interactive.isflive.org/ai-insights/series",
            target: "_blank",
            width: "38.6%",
            height: "8%",
            left: "50.8%",
            top: "31%"
        },
        {
            label: "ISF Library",
            href: "https://www.isflive.org/s/knowledge-library",
            target: "_blank",
            width: "38.6%",
            height: "8%",
            left: "50.8%",
            top: "42%"
        },
        {
            label: "Meet the Experts",
            href: "https://www.isflive.org/s/about-us/meet-the-experts",
            target: "_blank",
            width: "38.6%",
            height: "8%",
            left: "50.8%",
            top: "53%"
        },
        {
            label: "Join our communities on ISF Live",
            href: "https://www.isflive.org/s/communities",
            target: "_blank",
            width: "42%",
            height: "9%",
            left: "29.1%",
            top: "72%"
        },
    ]}>

    </MappedImage>
}

const IsfResearchMetadata = {
    ...IAMetadata,
    name: "ISF Research",
    dismiss: {
        ...IAMetadata.dismiss,
        left: "87.9%",
        top: "19%",
        height: "4%"
    },
    extras: {
        style: {
            width: "62%"
        }
    }
}

const IsfService = () => {

    return <MappedImage 
        imageURL="https://assets.swoogo.com/uploads/full/4594567-672280a6873cf.png"
        links={[
            {
                label: "Cyber Simulation Exercise",
                href: "https://www.isflive.org/s/services-overview/cyber-simulation-exercise",
                target: "_blank",
                width: "38.6%",
                height: "8%",
                left: "11%",
                top: "31%"
            },
            {
                label: "Supplier Risk Management",
                href: "https://www.isflive.org/s/services-overview/supply-chain-management",
                target: "_blank",
                width: "38.6%",
                height: "8%",
                left: "11%",
                top: "42%"
            },
            {
                label: "Cyber Regulation",
                href: "https://www.isflive.org/s/services-overview/cyber-regulation",
                target: "_blank",
                width: "38.6%",
                height: "8%",
                left: "11%",
                top: "53%"
            },
            {
                label: "Incident Response Toolkit",
                href: "https://www.isflive.org/s/services-overview/incident-response-toolkit",
                target: "_blank",
                width: "38.6%",
                height: "8%",
                left: "50.8%",
                top: "31%"
            },
            {
                label: "Find out more about ISF Services",
                href: "https://www.isflive.org/s/services-overview",
                target: "_blank",
                width: "38.6%",
                height: "8%",
                left: "50.8%",
                top: "42%"
            },
            {
                label: "Meet the Experts",
                href: "https://www.isflive.org/s/about-us/meet-the-experts",
                target: "_blank",
                width: "38.6%",
                height: "8%",
                left: "50.8%",
                top: "53%"
            },
            {
                label: "Get in touch with our experts - ISF Services",
                href: "mailto:services@securityforum.org",
                isExternal: true,
                width: "42%",
                height: "9%",
                left: "29.1%",
                top: "72%"
            }
        ]}
    ></MappedImage>
}

const IsfServiceMetadata = {
    ...IAMetadata,
    name: "ISF Service",
    dismiss: {
        ...IAMetadata.dismiss,
        left: "87.9%",
        top: "19%",
        height: "4%"
    },
    extras: {
        style: {
            width: "62%"
        }
    }
}

const podcast = "https://assets.swoogo.com/uploads/full/4594568-672280a6881b2.png"

const PodcastSign = () => {

    return <MappedImage imageURL={podcast} links={[
        {
            label: "The Never Normal - Peter Hinssen",
            href: "https://www.isflive.org/s/community-webcast/a2EQC0000013wTW2AY/the-never-normal",
            target: "_blank",
            width: "78.6%",
            height: "8%",
            left: "11%",
            top: "31%"
        },
        {
            label: "The Power of Inclusive Leadership - Helle Thorning-Schmidt",
            href: "https://www.isflive.org/s/community-webcast/a2EQC000000ARGh2AO/the-power-of-inclusive-leadership",
            target: "_blank",
            width: "78.6%",
            height: "8%",
            left: "11%",
            top: "42%"
        },
        {
            label: "Cyber Warfare and Democracy in the Age of Artificial Intelligence",
            href: "https://www.isflive.org/s/community-webcast/a2EQC000001GNL32AO/cyber-warfare-and-democracy-in-the-age-of-artificial-intelligence",
            target: "_blank",
            width: "78.6%",
            height: "8%",
            left: "11%",
            top: "53%"
        },
        {
            label: "Listen and subscribe to our podcasts",
            href: "https://www.isflive.org/s/isf-videos-podcasts",
            target: "_blank",
            width: "42.6%",
            height: "8%",
            left: "29%",
            top: "72%"
        }
    ]}></MappedImage>
}

const PodcastSignMetadata = {
    ...IsfServiceMetadata,
    name: "Podcast Sign",
    extras: {
        style: {
            width: "62%"
        }
    }
}

export default {
    day: new Date("2024-11-12 19:00:00.000-05:00"),
    tvs: [
        [IsfResearch, IsfResearchMetadata],
        [ISFAssure, IAMetadata],
        [IsfService, IsfServiceMetadata],
        [PodcastSign, PodcastSignMetadata],
        membership,
        []
    ]
}